import api from "./connector";

export const getConversationHistory = (sessionId, projectId) => {
  return api
    .get(`/api/usage/conversation-history/${sessionId}?projectId=${projectId}`)
    .then((response) => response)
    .catch((error) => error);
};

//   export const getSolutionById = (solutionId) => {
//     return api.get(`/ai-solutions/${solutionId}`);
//   };

//   export const createSolution = (payload) => {
//     return api.post(`/ai-solutions`, payload);
//   };

//   export const updateSolution = (solutionId, payload) => {
//     return api.patch(`/ai-solutions/${solutionId}`, payload);
//   };

//   export const deleteSolution = (solutionId) => {
//     return api.delete(`/ai-solutions/${solutionId}`);
//   };
